// extracted by mini-css-extract-plugin
export default {"collapsibleContainer":"CollapsibleContainer-module__collapsibleContainer___2aT48"};